import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const MultiPromptBuilderPage = loadAsyncComponent(
  () => import(/* webpackChunkName: "MultiPromptBuilderPage" */ './Container'),
  'page'
);
